import { useConfig } from 'domains/config/hooks'
import { useI18n } from 'domains/i18n/hooks'
import { getRelativeDate } from 'ui/utils/general-utils'

const dateFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
} satisfies Intl.DateTimeFormatOptions
const timeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
} satisfies Intl.DateTimeFormatOptions

export const useFormattedDate = (date) => {
  const { t } = useI18n()
  const config = useConfig()
  const locale = config?.context?.userLocale ?? []
  const eventDate = new Date(date)
  const currentDate = new Date()
  const midnight = new Date(currentDate)
  midnight.setHours(24, 0, 0, 0)
  const timeUntilMidnight = midnight.valueOf() - currentDate.valueOf()
  const fullDateTime = eventDate.toString()
  const time = new Intl.DateTimeFormat(locale, timeFormatOptions).format(
    eventDate,
  )

  let relativeDate = getRelativeDate(eventDate, currentDate)
  switch (relativeDate) {
    case 'today':
      relativeDate = t('dateTime.today')
      break
    case 'yesterday':
      relativeDate = t('dateTime.yesterday')
      break
    default:
      relativeDate = new Intl.DateTimeFormat(locale, dateFormatOptions).format(
        eventDate,
      )
  }

  const srText = t('dateTime.srText', { date: relativeDate, time })

  return {
    date: relativeDate,
    srText,
    time,
    fullDateTime,
    timeUntilMidnight,
  }
}
